import { Button } from "@/app/_module/components/ui/button";
import { Dialog, ResponsiveDialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/app/_module/components/ui/dialog";

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string;
}

export const ConfirmDeleteModal = function({ open, onClose, onConfirm, itemName = "this reminder" }: ConfirmDeleteModalProps) {
  return <Dialog onOpenChange={onClose} open={open}>
    <ResponsiveDialogContent size="md">
      <DialogHeader>
        <DialogTitle>Delete Reminder</DialogTitle>
      </DialogHeader>
      <p>Are you sure you want to delete <strong>{itemName}</strong>? This action cannot be undone.</p>
      <DialogFooter>
        <Button onClick={onClose} variant="outline">Cancel</Button>
        <Button onClick={onConfirm} variant="destructive">Delete</Button>
      </DialogFooter>
    </ResponsiveDialogContent>
  </Dialog>
}
